import AddWidget from './AddWidget';

export default AddWidget;
